module.exports = __webpack_public_path__ + "static/vtks_distress-8bb22787b142ade6962c2fdcf0913f82.ttf";